module.exports = __webpack_public_path__ + "img/sort_desc.a3959c6d.svg";